(function(){
"use strict";
var Bar={
el:null,textEl:null,progressEl:null,threshold:0,msg:"",successMsg:"",
init:function(){
// FIX: Immer neu aus dem DOM holen – nach refreshDrawer() ist das alte el entfernt
this.el=document.getElementById("FreeShippingBar");
if(!this.el)return;
this.textEl=this.el.querySelector("[data-free-shipping-text]");
this.progressEl=this.el.querySelector("[data-free-shipping-progress]");
this.threshold=parseInt(this.el.dataset.threshold,10);
this.msg=this.el.dataset.message;
this.successMsg=this.el.dataset.successMessage;
this.bind();
},
bind:function(){
var self=this;
// Totals-Mutation beobachten
var totals=document.querySelector(".totals__total-value");
if(totals){new MutationObserver(function(){self.doFetch();}).observe(totals,{childList:true,characterData:true,subtree:true});}
// fetch-Interceptor nur EINMAL setzen
if(window._fsbFetchPatched)return;
window._fsbFetchPatched=true;
var origFetch=window.fetch;
window.fetch=function(){
var args=arguments;
return origFetch.apply(this,args).then(function(r){
if(typeof args[0]==="string"&&args[0].indexOf("/cart")>-1)setTimeout(function(){self.doFetch();},300);
return r;
});
};
},
doFetch:function(){
var self=this;
window.fetch("/cart.js").then(function(r){return r.json();}).then(function(c){self.update(c.total_price);}).catch(function(){});
},
update:function(total){
// FIX: el bei jedem Update neu holen – nach Drawer-Refresh zeigt Bar.el ins Nichts
this.el=document.getElementById("FreeShippingBar");
if(!this.el)return;
this.textEl=this.el.querySelector("[data-free-shipping-text]");
this.progressEl=this.el.querySelector("[data-free-shipping-progress]");
if(!this.progressEl)return;
var pct=Math.min((total/this.threshold)*100,100);
this.progressEl.style.width=pct+"%";
if(total>=this.threshold){
this.textEl.innerHTML=this.successMsg;
this.el.classList.add("is-reached");
}else{
var rem=(this.threshold-total)/100;
var fmt=rem.toFixed(2).replace(".",",")+(" \u20ac");
this.textEl.innerHTML=this.msg.replace("{{ amount }}",fmt);
this.el.classList.remove("is-reached");
}
}
};

// FIX: Global exponieren damit refreshDrawer() Bar.init() nach DOM-Update aufrufen kann
window.FreeShippingBar=Bar;

if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){Bar.init();});
else Bar.init();
})();
